<template>
    <modal printButton downloadButton :close="closeModal" :printStyle="printStyle" :title="title">
        <h3 slot="modalHeader"><i class="uk-icon-tags"></i> Лизинг</h3>
        <div v-if="auth" slot="modalBody" ref="root">
            <div ref="leasingModalContent">
                <ul class="list" v-if="auth && list.length > 0">
                    <item
                        v-for="(l, i) in list"
                        :key="i"
                        :leasing="l"
                        inModal 
                    />
                </ul>
            </div>
            <template v-if="!isIE">
                <div class="loading-holder"  v-if="isLoading">
                    <loading :isWord="false" />
                </div>
                <div class="target" v-if-i-visible="{ callback: getMoreLeasings, root: this.$refs.root }">
                </div>
                
            </template>
            
            <div v-if="isIE && this.list.length < this.pagination.rows_count" class="btn-holder">
                <btn @click.native="getMoreLeasings">
                    <span><i :class="{ 'uk-icon-spin': isLoading }" class="uk-icon-refresh"></i> Загрузить ещё</span>
                </btn>
            </div>
        </div>
        <demo-message slot="modalBody" v-if="!auth" />
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import blueButton from '@/components/ui/blueButton/blueButton.vue'
import demoMessage from '@/components/ui/demoMessage/demoMessage.vue'
import loading from '@/components/ui/loading/loading.vue'
import leasingListItem from '@/components/card/zalogLeasing/leasing/leasingListItem.vue'

export default {
    props: {
        list: Array,
        printStyle: String,
        title: String
    },
    components: {
        modal,
        item: leasingListItem,
        btn: blueButton,
        loading,
        demoMessage
    },
    computed: {
        isLoading() { return this.$store.state.card?.zalogLeasing?.leasing?.isLoading },
        pagination() { return this.$store.state.card?.zalogLeasing?.leasing?.pagination},
        isIE() { !window.hasOwnProperty('IntersectionObserver') }
    },
    methods: {
        closeModal() { this.$emit('close') },
        getMoreLeasings(entries) {
            if(this.pagination?.max_row_on_page === this.pagination?.rows_count) {
                return
            }
            if(!this.isIE) {
                if(entries[0].isIntersecting) {
                    this.$store.dispatch('card/zalogLeasing/getLeasingInfo', {
                        limit: 15,
                        offset: 15 * this.pagination.current_page
                    })
                }
            } else {
                this.$store.dispatch('card/zalogLeasing/getLeasingInfo', {
                    limit: 15,
                    offset: 15 * this.pagination.current_page
                })
            }
        }
    }
}
</script>

<style lang="sass" scoped>
.list
    margin-bottom: 15px
.btn-holder
    text-align: center
    margin-bottom: 15px
.loading-holder
    position: relative
    padding: 15px 0
</style>